import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "301",
  "slug": "spot-peru-from-satellite-imagery",
  "title": "How to Recognise Peru in Satellite Images",
  "excerpt": "Peru has a dry Pacific coastal strip, high Andean terrain inland, and Amazon lowlands to the east.",
  "date": "2026-04-11",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/peru.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Peru has a dry Pacific coastal strip, high Andean terrain inland, and Amazon lowlands to the east. Rivers crossing the coastal desert create narrow corridors of cultivated land. A regional view makes the change across the Andes clearer than a single field or hillside."
    },
    {
      "type": "heading",
      "text": "A desert coast below the Andes"
    },
    {
      "type": "paragraph",
      "text": "Follow a coastal river inland from the Pacific. Compare the narrow green valley with the surrounding dry slopes, then look east of the Andes."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Northern Chile shares an arid coast backed by mountains. The eastern forest continues into Brazil and neighbouring countries. Identify the side of the Andes before using vegetation to choose a country."
    }
  ],
  "imageAlt": "Peru regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
